import React from 'react'

export default function Footer() {
    return (
        <div>
          <footer className="content-footer footer bg-footer-theme">
            <div className="container-xxl d-flex flex-wrap justify-content-between py-2 flex-md-row flex-column">
              <div className="mb-2 mb-md-0 text-sm">
                ©2024 <span className='text-warning'>Multi Store Markiting</span>
              </div>
              <div>
              </div>
            </div>
          </footer>
          <div className="content-backdrop fade" />
        </div>
      );
}
